export interface RobinhoodV2Router {
  address: string
  name: string
}

export const ROBINHOOD_V2_ROUTERS: RobinhoodV2Router[] = [
  {
    address: '0x872a7222E5ecBD8366b4341d2e9c8bc8b17fbE8e',
    name: 'GRXSwap V2',
  },
]
